import React, { useMemo } from "react";
import { optionsFormeSociale, FORMES_FICHE_HISTORIQUES } from "../formeSociale";

// Forme sociale de la fiche client, choisie dans la liste « Formes » des
// Paramètres KYC/LAB (EtatGlobal.kycReferentiel). Tant que le référentiel
// n'est pas chargé, l'ancienne liste reste proposée.
export default function FormeSocialeSelect({ formes, value, onChange, className = "", name = "formeSociale", placeholder = "Forme Sociale" }) {
  const { referentiel, hors } = useMemo(() => optionsFormeSociale(formes, value), [formes, value]);
  const charge = Array.isArray(formes) && formes.length > 0;

  return (
    <select name={name} value={value || ""} onChange={(e) => onChange(e.target.value)} className={className}>
      <option value="">{placeholder}</option>
      {charge ? (
        <>
          <optgroup label="Paramètres KYC/LAB">
            {referentiel.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </optgroup>
          {hors.length > 0 && (
            <optgroup label="Hors référentiel (sans effet sur le risque)">
              {hors.map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </optgroup>
          )}
        </>
      ) : (
        [...new Set([...FORMES_FICHE_HISTORIQUES, ...(value ? [value] : [])])].map((v) => (
          <option key={v} value={v}>
            {v}
          </option>
        ))
      )}
    </select>
  );
}
